<template>
	<div>
		<el-page-header @back="goBack" content="维护测评题目"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>

				<div style="margin-top: 30px">
					<el-button type="primary" plain @click="handelResultSet"
						>结果设置
					</el-button>
					<el-button type="danger" plain @click="delQuestionBank"
						>删除所有题目
					</el-button>
					<el-button type="info" plain @click="handleRelationSet"
						>关联设置
					</el-button>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div>
					<span>类型：</span>
					<span>
						<el-tag
							class="tag-marr"
							:key="index"
							:class="{ activeBg: selectedLevel1Id == item.examDimensionId }"
							effect="plain"
							@click="activeEvent(item, 'level1')"
							v-for="(item, index) in level1List"
							>{{ item.name }}</el-tag
						>
						<el-tag
							class="tag-marr"
							effect="plain"
							@click="handleDimensionEdit('level1')"
							><i class="el-icon-edit"></i
						></el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							@click="handleDimensionAdd('level1')"
							><i class="el-icon-plus"></i
						></el-tag>
					</span>
				</div>
				<div class="marr">
					<span>维度一：</span>
					<span>
						<el-tag
							effect="plain"
							class="tag-marr"
							:class="{ activeBg1: selectedLevel2Id == item.examDimensionId }"
							@click="activeEvent(item, 'level2')"
							:key="index"
							v-for="(item, index) in level2List"
							type="warning"
							>{{ item.name }}
						</el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="warning"
							@click="handleDimensionEdit('level2')"
							v-if="!selectedLevel2Info.isComprehensive"
							><i class="el-icon-edit"></i
						></el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="warning"
							@click="handleDimensionAdd('level2')"
							><i class="el-icon-plus"></i
						></el-tag>
					</span>
				</div>
				<div class="marr" v-if="level2List.length > 0 && !selectedLevel2Info.isComprehensive">
					<span>维度二：</span>
					<span>
						<el-tag
							effect="plain"
							class="tag-marr"
							:class="{ activeBg2: selectedLevel3Id == item.examDimensionId }"
							@click="activeEvent(item, 'level3')"
							:key="index"
							v-for="(item, index) in level3List"
							type="danger"
							>{{ item.name }}
						</el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="danger"
							@click="handleDimensionEdit('level3')"
							v-if="level3List.length > 0"
							><i class="el-icon-edit"></i
						></el-tag>
						<el-tag
							class="tag-marr"
							effect="plain"
							type="danger"
							@click="handleDimensionAdd('level3')"
							><i class="el-icon-plus"></i
						></el-tag>
					</span>
				</div>
				<div class="marr">
					<span>测评题目：</span>
					<el-button
						type="success"
						size="small"
						v-if="currentDimensionInfo.code != 'IBB' && !currentDimensionInfo.isComprehensive"
						@click="handleSubjectIncrease('add')"
						>添加 <i class="el-icon-plus"></i
					></el-button>
					<el-button
						v-else-if="currentDimensionInfo.code == 'IBB'"
						type="success"
						size="small"
						@click="handleSubjectIncrease('question')"
						>关联题目<i class="el-icon-plus"></i
					></el-button>
					<span v-if="currentDimensionInfo.isComprehensive" style="color: #909399; font-size: 14px;">
						（综合维度仅供查看，不可添加题目）
					</span>
				</div>
				<div style="margin-top: 20px" v-if="currentDimensionInfo.code != 'IBB' || currentDimensionInfo.isComprehensive">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="tableData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="80"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="examDimensionVo"
								label="维度"
								width="120"
								align="center"
							>
								<template slot-scope="scope">
									{{ emptyShow(scope.row.examDimensionVo).name }}
								</template>
							</el-table-column>
							<el-table-column
								prop="name"
								label="题目"
								min-width="300"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="viewName"
								label="布局"
								width="100"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="answers"
								label="答案"
								width="80"
								align="center"
							>
							</el-table-column>

							<el-table-column
								prop="payPrice"
								label="分数"
								width="120"
								align="center"
							>
								<template slot-scope="scope">
									{{ scope.row.minScore }}~{{ scope.row.maxScore }}
								</template>
							</el-table-column>

							<el-table-column
								prop="seq"
								label="排序"
								width="100"
								align="center"
							>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="220"
								v-if="!currentDimensionInfo.isComprehensive"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleSubjectIncrease('edit', scope.row)"
										type="success"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleSubjectIncrease('answer', scope.row)"
										type="warning"
										plain
										>答案
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div style="margin-top: 12px" v-else>
					<el-tag
						effect="plain"
						class="tag-marr"
						:key="index"
						v-for="(item, index) in tableData"
						type="success"
						>{{ item.seq }}
					</el-tag>
				</div>
			</div>
		</div>
		<!-- 添加维度/基准弹框 -->
		<el-dialog
			:title="getDialogTitle()"
			:visible.sync="dialogVisible"
			width="800px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('dimension')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<!-- <el-form-item label="维度" v-if="clickType == 'jz'">
						{{ dimensionInfo.name }}
					</el-form-item> -->
					<el-form-item label="ICON">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
									v-if="params.icon"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="!params.icon"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>

					<el-form-item label="名称" prop="name">
						<el-input placeholder="请填写名称" v-model="params.name"></el-input>
					</el-form-item>

					<el-form-item prop="code" label="标识">
						<el-input 
							placeholder="请填写标识" 
							v-model="params.code"
							:disabled="isEditMode"
						></el-input>
					</el-form-item>

					<el-form-item
						label="计分方式"
						prop="scoreType"
						v-if="clickType == 'jz'"
					>
						<el-radio v-model="params.scoreType" :label="0">计入总分</el-radio>
						<el-radio v-model="params.scoreType" :label="1">平均分</el-radio>
					</el-form-item>
					<el-form-item label="说明" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入说明"
							v-model="params.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item prop="seq" label="序号">
						<el-input placeholder="请填写序号" v-model="params.seq"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 添加 编辑 题目弹框 -->
		<el-dialog
			title="添加/编辑题目"
			:visible.sync="dialogVisibleTopic"
			width="800px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleFormTopic"
					:rules="rulesTopic"
					:model="topicParams"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item label="类型" v-if="selectedLevel1Info.name">
						{{ selectedLevel1Info.name }} 【 {{ selectedLevel1Info.code }} 】
					</el-form-item>
					<el-form-item label="维度一" v-if="selectedLevel2Info.name">
						{{ selectedLevel2Info.name }} 【 {{ selectedLevel2Info.code }} 】
					</el-form-item>
					<el-form-item label="维度二" v-if="selectedLevel3Info.name">
						{{ selectedLevel3Info.name }} 【 {{ selectedLevel3Info.code }} 】
					</el-form-item>
					<template v-if="clickType == 'edit'">
						<el-form-item label="当前维度" v-if="topicParams.examDimensionVo">
							{{ topicParams.examDimensionVo.name }} 【
							{{ topicParams.examDimensionVo.code }} 】
						</el-form-item>
					</template>
					<el-form-item label="布局" prop="view">
						<el-select
							v-model="topicParams.view"
							clearable
							placeholder="请选择布局"
							style="width: 100%"
						>
							<el-option label="方式一(列表)" value="ve1"></el-option>
							<!-- <el-option label="方式二(四维)" value="ve2"></el-option> -->
						</el-select>
					</el-form-item>
					<el-form-item label="图片">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy(index)"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="isMoer && srcList.length === 0"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>
					<el-form-item prop="name" label="题目">
						<el-input
							placeholder="请填写题目"
							v-model="topicParams.name"
						></el-input>
					</el-form-item>
					<el-form-item prop="subtitle" label="副标题">
						<el-input
							placeholder="请填写副标题"
							v-model="topicParams.subtitle"
						></el-input>
					</el-form-item>
					<el-form-item label="解析" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请填写解析"
							v-model="topicParams.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item prop="tx" label="排序">
						<el-input
							type="number"
							placeholder="请填写排序"
							v-model="topicParams.seq"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleTopic = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEditTopic"
					>提 交</el-button
				>
			</span>
		</el-dialog>

		<el-dialog title="关联题目" :visible.sync="dialogVisibleQuestion">
			<el-table
				ref="questionTable"
				:data="questionTableData"
				border
				row-key="seq"
				v-loading="loading"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="seq" label="序号" width="80">
					<template slot-scope="scope">
						{{ scope.row.seq }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="题目"> </el-table-column>
			</el-table>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleQuestion = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="submitQuestion"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 添加答案弹框 -->
		<el-dialog
			title="添加答案"
			:visible.sync="dialogVisibleAnswer"
			width="700px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<el-tabs
				type="card"
				v-model="languageCode"
				@tab-click="handleTabClick('answer')"
			>
				<el-tab-pane
					v-for="(item, index) in languageList"
					:label="item.name"
					:name="item.code"
					:key="index"
				></el-tab-pane>
			</el-tabs>
			<div style="margin-bottom: 10px">
				<span>题目：{{ topicParams.name }}</span>
				<div v-if="topicParams.icon">
					<img
						:src="topicParams.icon"
						style="width: 100px; height: 100px; object-fit: contain"
					/>
				</div>
			</div>
			<div style="margin-bottom: 10px">
				<span>答题方式：</span>
				<span>{{ topicParams.answerWayName }}</span>
			</div>
			<div style="margin-bottom: 10px">
				<span>布局方式：</span>
				<span>{{ topicParams.viewName }}</span>
			</div>
			<div class="public-table-data">
				<el-table
					ref="multipleTable"
					size="mini"
					:data="answerTableData"
					border
					style="width: 100%"
					row-key="menuId"
					v-loading="loading"
				>
					<el-table-column type="index" label="序号" width="80" align="center">
					</el-table-column>
					<el-table-column prop="icon" label="图标" width="120" align="center">
						<template slot-scope="scope">
							<div class="diplay" @click="answerChangIndex(scope.$index)">
								<div class="screenshot">
									<span class="slideshow">
										<el-image
											v-if="scope.row.icon"
											style="width: 40px; height: 40px; border-radius: 6px"
											:src="scope.row.icon"
											fit="cover"
											@click="getPolicyAnswer"
										/>
									</span>
									<div
										class="up-btn"
										style="width: 40px; height: 40px; line-height: 45px"
										@click="getPolicyAnswer"
										v-if="!scope.row.icon"
									>
										<i class="el-icon-plus"></i>
									</div>
								</div>
								<input
									type="file"
									ref="fileAnswer"
									id="uploadFile"
									@change="getFileAnswer()"
									accept="image/png,image/jpg"
								/>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="答案" width="200" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.name"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="score" label="分值" width="80" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.score"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="seq" label="排序" width="80" align="center">
						<template slot-scope="scope">
							<el-input
								type="text"
								v-model="scope.row.seq"
								size="mini"
							></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button
								size="mini"
								@click="handleAnswerDelete(scope.row, scope.$index)"
								type="danger"
								plain
								>删除</el-button
							>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleAnswer = false"
					>取 消</el-button
				>
				<el-button size="medium" type="success" @click="handleAddAnswer"
					>添加答案</el-button
				>
				<el-button size="medium" type="primary" @click="submitAnswer"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { ossUpload } from "@utils/filters/upload";
import { emptyShow, isEmpty } from "@utils/tools";

export default {
	name: "mjywlList",
	data() {
		return {
			dimensionInfoList: [],
			emptyShow,
			isEmpty,
			loading: false,
			detalisObj: {},
			// 三级维度数据
			level1List: [], // nodeLevel = 1, parentId = 0
			level2List: [], // nodeLevel = 2, parentId = 选中的一级维度ID
			level3List: [], // nodeLevel = 3, parentId = 选中的二级维度ID
			// 选中的维度ID
			selectedLevel1Id: 0,
			selectedLevel2Id: 0,
			selectedLevel3Id: 0,
			// 选中的维度对象
			selectedLevel1Info: {},
			selectedLevel2Info: {},
			selectedLevel3Info: {},
			// 当前操作的维度信息（用于编辑等操作）
			currentDimensionInfo: {},
			dialogVisible: false,
			rules: {
				name: [{ required: true, message: "请填写名称", trigger: "change" }],
				code: [{ required: true, message: "请填写标识", trigger: "change" }],
				seq: [{ required: true, message: "请填写标识", trigger: "change" }],
			},
			params: {},
			srcList: [],
			isMoer: true,
			tableData: [],
			dialogVisibleTopic: false,
			topicParams: {},
			rulesTopic: {
				view: [{ required: true, message: "请选择布局", trigger: "change" }],
				name: [{ required: true, message: "请填写题目", trigger: "change" }],
			},
			clickType: "",
			dialogVisibleAnswer: false,
			dialogVisibleQuestion: false,
			questionTableData: [],
			answerParams: {},
			answerTableData: [],
			answerDataIndex: "",
			srcListAnswer: [],
			isMoerAnswer: true,
			languageList: [],
			languageCode: "",
			multipleSelection: [],
			isEditMode: false,
		};
	},
	mounted() {
		this.getAppraisalData(true);
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question") {
				this.srcList = [];
				this.isMoer = false;
				if (this.topicParams.questionId) {
					this.getSubjectInfo(this.topicParams.questionId);
				} else {
					this.isMoer = true;
				}
			} else if (e == "answer") {
				this.getAnswerList(this.topicParams.questionId);
			} else if (e == "dimension") {
				// 只有在编辑模式下才重新获取维度信息
				if (this.isEditMode) {
					this.handleDimensionEdit(this.clickType);
				}
				// 新建模式下不需要做任何操作，保持当前的params状态
			}
		},
		async getQuestionContentInfo() {
			const { data: resData } = await this.$get(
				`exam/question/info/${this.topicParams.questionId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			this.topicParams = resData.data;
			this.isMoer = false;
			this.$nextTick(() => {
				this.isMoer = true;
			});
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData(e) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			if (e) {
				this.getDimensionList();
			}
		},
		/**
		 * 获取二级维度列表
		 */
		getLevel2List() {
			this.level2List = [];
			this.selectedLevel2Id = 0;
			this.selectedLevel2Info = {};
			
			if (this.selectedLevel1Id) {
				// 获取原有的二级维度列表
				const originalLevel2List = this.dimensionInfoList.filter(
					(item) => item.parentId == this.selectedLevel1Id && item.nodeLevel == 2
				);
				
				// 检查选中的一级维度code是否包含DWRG
				if (this.selectedLevel1Info.code && this.selectedLevel1Info.code.includes('DWRG')) {
					// 在前面添加【综合】维度
					const comprehensiveDimension = {
						examDimensionId: -1, // 使用负数ID表示特殊维度
						name: '综合',
						code: this.selectedLevel1Info.code + '_COMPREHENSIVE',
						parentId: this.selectedLevel1Id,
						nodeLevel: 2,
						isComprehensive: true // 标记为综合维度
					};
					this.level2List = [comprehensiveDimension, ...originalLevel2List];
				} else {
					this.level2List = originalLevel2List;
				}
				
				if (this.level2List.length > 0) {
					this.selectedLevel2Id = this.level2List[0].examDimensionId;
					this.selectedLevel2Info = this.level2List[0];
					this.currentDimensionInfo = this.level2List[0];
					
					// 如果选中的是综合维度，直接获取题目列表，否则获取三级维度
					if (this.selectedLevel2Info.isComprehensive) {
						this.level3List = [];
						this.selectedLevel3Id = 0;
						this.selectedLevel3Info = {};
						this.getSubjectList();
					} else {
						this.getLevel3List();
					}
				} else {
					// 如果没有二级维度，直接获取题目列表
					this.getSubjectList();
				}
			}
		},
		
		/**
		 * 获取三级维度列表
		 */
		getLevel3List() {
			this.level3List = [];
			this.selectedLevel3Id = 0;
			this.selectedLevel3Info = {};
			
			if (this.selectedLevel2Id) {
				this.level3List = this.dimensionInfoList.filter(
					(item) => item.parentId == this.selectedLevel2Id && item.nodeLevel == 3
				);
				
				if (this.level3List.length > 0) {
					this.selectedLevel3Id = this.level3List[0].examDimensionId;
					this.selectedLevel3Info = this.level3List[0];
					this.currentDimensionInfo = this.level3List[0];
				}
			}
			
			// 无论是否有三级维度，都获取题目列表
			this.getSubjectList();
		},
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.level1List = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.dimensionInfoList = resData.data;
				// 获取一级维度（nodeLevel = 1, parentId = 0）
				this.level1List = resData.data.filter((item) => item.parentId == 0 && item.nodeLevel == 1);
				
				if (this.level1List.length > 0) {
					this.selectedLevel1Id = this.level1List[0].examDimensionId;
					this.selectedLevel1Info = this.level1List[0];
					this.currentDimensionInfo = this.level1List[0];
					this.getLevel2List();
				}
			}
		},
		/**
		 * 维度切换
		 */
		activeEvent(item, level) {
			if (level == "level1") {
				this.selectedLevel1Id = item.examDimensionId;
				this.selectedLevel1Info = item;
				this.currentDimensionInfo = item;
				this.getLevel2List();
			} else if (level == "level2") {
				this.selectedLevel2Id = item.examDimensionId;
				this.selectedLevel2Info = item;
				this.currentDimensionInfo = item;
				
				// 如果选中的是综合维度，直接获取题目列表
				if (item.isComprehensive) {
					this.level3List = [];
					this.selectedLevel3Id = 0;
					this.selectedLevel3Info = {};
					this.getSubjectList();
				} else {
					this.getLevel3List();
				}
			} else if (level == "level3") {
				this.selectedLevel3Id = item.examDimensionId;
				this.selectedLevel3Info = item;
				this.currentDimensionInfo = item;
				this.getSubjectList();
			}
		},
		/**
		 * 删除维度
		 */
		deleteDimension(code, e) {
			this.$confirm("此操作将永久删除当前数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/datum/info/${this.$route.query.examId}/${code}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getJZList();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 编辑维度
		 */
		async handleDimensionEdit(level) {
			this.clickType = level;
			this.isEditMode = true; // 设置为编辑模式
			let dimensionInfo = {};
			
			if (level == "level1") {
				dimensionInfo = this.selectedLevel1Info;
			} else if (level == "level2") {
				dimensionInfo = this.selectedLevel2Info;
				// 如果是综合维度，不允许编辑
				if (dimensionInfo.isComprehensive) {
					this.$message.warning("综合维度不允许编辑");
					return;
				}
			} else if (level == "level3") {
				dimensionInfo = this.selectedLevel3Info;
			}
			
			if (!dimensionInfo || !dimensionInfo.code) {
				this.$message.warning("请先选择要编辑的维度");
				return;
			}
			
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/dimension/info/${this.$route.query.examId}/${dimensionInfo.code}`,
				{
					headers: {
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			
			this.params = resData.data;
			this.srcList = [];
			if (resData.data.icon) {
				this.params.icon = resData.data.icon;
				this.srcList.push(resData.data.icon);
			}
			this.dialogVisible = true;
		},
		/**
		 * 添加维度
		 */
		handleDimensionAdd(level) {
			this.clickType = level;
			this.isEditMode = false; // 设置为新建模式
			this.dialogVisible = true;
			this.isMoer = true;
			this.srcList = [];
			
			// 根据级别设置父级ID和节点级别，并继承上级标识
			if (level == "level1") {
				this.params = {
					parentId: 0,
					nodeLevel: 1,
					code: this.$route.query.examId + "_",
					name: "",
					descr: "",
					seq: "",
					icon: ""
				};
			} else if (level == "level2") {
				if (!this.selectedLevel1Id) {
					this.$message.warning("请先选择一级维度");
					return;
				}
				this.params = {
					parentId: this.selectedLevel1Id,
					nodeLevel: 2,
					code: this.selectedLevel1Info.code + "_",
					name: "",
					descr: "",
					seq: "",
					icon: ""
				};
			} else if (level == "level3") {
				if (!this.selectedLevel2Id) {
					this.$message.warning("请先选择二级维度");
					return;
				}
				this.params = {
					parentId: this.selectedLevel2Id,
					nodeLevel: 3,
					code: this.selectedLevel2Info.code + "_",
					name: "",
					descr: "",
					seq: "",
					icon: ""
				};
			}
		},
		/**
		 * 维度/基准数据保存
		 */
		handleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.params.examId = this.$route.query.examId;
					const { data: resData } = await this.$post(
						"exam/dimension/info",
						this.params,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					if (resData.result != 200) return;
					this.$message.success("操作成功!");
					
					// 刷新维度列表
					this.getDimensionList();
					this.dialogVisible = false;
					this.params = {};
					this.srcList = [];
				});
			});
		},
		/**
		 * 获取题目列表
		 */
		async getSubjectList() {
			this.loading = true;
			
			// 确定当前使用的维度信息
			let currentDimension = {};
			let isComprehensiveMode = false;
			
			if (this.selectedLevel3Id && this.selectedLevel3Info.code) {
				currentDimension = this.selectedLevel3Info;
			} else if (this.selectedLevel2Id && this.selectedLevel2Info.code) {
				currentDimension = this.selectedLevel2Info;
				// 检查是否为综合维度
				if (this.selectedLevel2Info.isComprehensive) {
					isComprehensiveMode = true;
				}
			} else if (this.selectedLevel1Id && this.selectedLevel1Info.code) {
				currentDimension = this.selectedLevel1Info;
			}
			
			// 更新当前维度信息
			this.currentDimensionInfo = currentDimension;
			
			if (!currentDimension.code) {
				this.loading = false;
				this.tableData = [];
				return;
			}
			
			let temp = {
				examId: this.$route.query.examId,
			};
			
			let api = "/exam/question/list";
			
			// 如果是综合维度模式，获取该类型的所有题目
			if (isComprehensiveMode) {
				// 使用一级维度的code来获取该类型的所有题目
				temp.examDimensionCode = this.selectedLevel1Info.code;
			} else {
				temp.examDimensionCode = currentDimension.code;
				
				if (currentDimension.code == "IBB") {
					api = "/exam/question/dimension/get";
					temp.dimensionId = currentDimension.examDimensionId;
				}
			}
			
			const { data: resData } = await this.$get(api, {
				params: temp,
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (emptyShow(resData.data)) {
				this.tableData = resData.data;
			} else {
				this.tableData = [];
			}
		},
		/**
		 * 测评题目添加/编辑相关
		 */
		async handleSubjectIncrease(type, data) {
			this.clickType = type;
			if (type == "add") {
				this.isMoer = true;
				this.topicParams = {};
				this.srcList = [];
				this.dialogVisibleTopic = true;
			} else if (type == "edit") {
				this.isMoer = true; // 编辑时也需要显示上传按钮
				this.getSubjectInfo(data.questionId);
				this.dialogVisibleTopic = true;
			} else if (type == "answer") {
				this.getSubjectInfo(data.questionId);
				this.getAnswerList(data.questionId);
				this.dialogVisibleAnswer = true;
			} else if (type == "question") {
				let temp = {
					examId: this.$route.query.examId,
				};
				const { data: resData } = await this.$get("/exam/question/list", {
					params: temp,
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				});
				this.questionTableData = resData.data;

				this.dialogVisibleQuestion = true;
				setTimeout(() => {
					const filteredData = resData.data.filter((row) =>
						this.tableData.some(
							(item) => item.examQuestionId == row.examQuestionId
						)
					);
					filteredData.forEach((row) => {
						this.$refs.questionTable.toggleRowSelection(row, true);
					});
				}, 500);
			}
		},
		handleSelectionChange(val) {
			console.log("🚀 ~   ~ handleSelectionChange ~ val:", val);
			this.multipleSelection = val;
		},
		//提交关联题目
		submitQuestion() {
			this.$confirm("确认保存数据, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const { data: resData } = await this.$post(
					"exam/question/dimension/add",
					{
						questionIds: this.multipleSelection.map(
							(item) => item.examQuestionId
						),
						dimensionId: this.currentDimensionInfo.examDimensionId,
						dimensionCode: this.currentDimensionInfo.code,
					},
					{
						headers: {
							isLoading: true,
							// "Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("关联成功!");
				this.getSubjectList();
				this.dialogVisibleQuestion = false;
			});
		},
		/**
		 * 测评题目删除
		 */
		async handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/question/info/${row.questionId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getAppraisalData(false); //刷新总题目
				this.getSubjectList();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 测评题目数据提交
		 */
		handleEditTopic() {
			this.$refs.ruleFormTopic.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.topicParams.examId = this.$route.query.examId;
					if (this.clickType == "add") {
						this.topicParams.answerWay = "sel1";
						// 使用当前最深层级的维度代码
						if (this.selectedLevel3Info.code) {
							this.topicParams.examDimensionCode = this.selectedLevel3Info.code;
						} else if (this.selectedLevel2Info.code) {
							// 如果选中的是综合维度，使用一级维度的code
							if (this.selectedLevel2Info.isComprehensive) {
								this.topicParams.examDimensionCode = this.selectedLevel1Info.code;
							} else {
								this.topicParams.examDimensionCode = this.selectedLevel2Info.code;
							}
						} else if (this.selectedLevel1Info.code) {
							this.topicParams.examDimensionCode = this.selectedLevel1Info.code;
						}
						const { data: resData } = await this.$post(
							"exam/question/info",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.dialogVisibleTopic = false;
						this.$message.success("添加成功!");
					} else if (this.clickType == "edit") {
						const { data: resData } = await this.$put(
							"exam/question/info",
							this.topicParams,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						// this.dialogVisibleTopic = false;
						this.$message.success("修改成功!");
					}
					this.getAppraisalData(false); //刷新总题目
					this.getSubjectList();
				});
			});
		},
		/**
		 * 测评题目详情
		 */
		async getSubjectInfo(questionId) {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/exam/question/info/${questionId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.topicParams = resData.data;
			this.srcList = [];
			if (resData.data.icon) {
				this.topicParams.icon = resData.data.icon;
				this.srcList.push(resData.data.icon);
			}
			// 确保编辑时上传按钮可见
			this.isMoer = true;
		},
		/** 答案 start */
		// 获取答案的数据列表
		async getAnswerList(questionId) {
			this.answerTableData = [];
			const { data: resData } = await this.$get(`exam/answer/list`, {
				params: {
					questionId,
				},
				headers: {
					"Language-Code": this.languageCode,
				},
			});
			if (resData.result != 200) return;
			if (resData.data) {
				this.answerTableData = resData.data;
			} else {
				this.answerTableData = [];
			}
		},
		// 添加答案数据列表
		handleAddAnswer() {
			this.answerTableData.push({
				icon: "",
				name: "",
				score: "",
				seq: "",
				answerId: this.answerTableData.length,
			});
		},
		//提交答案
		submitAnswer() {
			this.$confirm("确认保存数据, 是否继续?", "提示", {
				type: "info",
			}).then(async () => {
				const { data: resData } = await this.$post(
					"exam/answer/list",
					{
						answers: this.answerTableData,
						questionId: this.topicParams.questionId,
					},
					{
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("添加成功!");
				this.getSubjectList();
				// this.dialogVisibleAnswer = false;
			});
		},
		//答案删除
		handleAnswerDelete(row, index) {
			if (!row.examAnswerId) {
				this.answerTableData.splice(index, 1);
			} else {
				this.$confirm("此操作将删除答案数据, 是否继续?", "提示", {
					type: "warning",
				}).then(async () => {
					const { data: resData } = await this.$delete(
						`exam/answer/info/${row.answerId}`,
						{
							headers: {
								isLoading: true,
							},
						}
					);
					if (resData.result != 200) return;
					this.getSubjectList();
					this.getAnswerList(this.topicParams.questionId);
					this.$message.success("删除成功!");
				});
			}
		},
		//答案图片设置相关
		getPolicyAnswer() {
			this.$refs.fileAnswer.dispatchEvent(new MouseEvent("click"));
		},
		async getFileAnswer() {
			const that = this;
			const { data: resData } = await this.$get("aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.fileAnswer.files[0],
				resData.data,
				"one", //'more','one'
				this.srcListAnswer
			);
			this.isMoerAnswer = false;
			this.srcListAnswer = addRoutes;
			this.answerTableData[this.answerDataIndex].icon = this.srcListAnswer[0];
		},
		answerChangIndex(val) {
			this.answerDataIndex = val;
		},

		handelResultSet() {
			this.$router.push({
				name: "XLTP_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		handleRelationSet() {
			this.$router.push({
				name: "XLTP_RELATION_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		delQuestionBank() {
			this.$confirm("此操作将永久删除该测评题库数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/question/list/${this.$route.query.examId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.getExamInfo();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 获取弹框标题
		 */
		getDialogTitle() {
			if (!this.clickType) return "维度管理";
			
			const levelMap = {
				level1: "一级维度",
				level2: "二级维度", 
				level3: "三级维度"
			};
			
			const levelName = levelMap[this.clickType] || "维度";
			
			// 检查是否有params.examDimensionId来判断是编辑还是添加
			if (this.params.examDimensionId) {
				return `编辑${levelName}`;
			} else {
				return `添加${levelName}`;
			}
		},
		goBack() {
			this.$router.back();
		},
		/**
		 * 图片上传
		 */
		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("aliyun/oss/sign", {
				headers: {
					isLoading: true,
					"Language-Code": this.languageCode,
				},
			});

			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			// 保持 isMoer 为 true，以便用户可以重新上传图片
			this.srcList = addRoutes;
			this.params.icon = this.srcList[0];
			this.topicParams.icon = this.srcList[0];
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}
.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}
.activeBg2 {
	background: #f56c6c;
	color: #fff;
}
</style>
